module.exports = __webpack_public_path__ + "media/images/rules-51b85f85e06dde5e8ebde27d0dacae8e.svg";